import { useEffect } from 'react'
import { useMap } from 'react-leaflet'
import L from 'leaflet'

interface MapControllerProps {
  onMapReady: (map: L.Map) => void
}

/**
 * Component to expose map instance to parent component
 */
export function MapController({ onMapReady }: MapControllerProps) {
  const map = useMap()

  useEffect(() => {
    if (map) {
      onMapReady(map)
    }
  }, [map, onMapReady])

  return null
}
